import React from "react";
import "./FreeConsultation.css";
// import free from "./Images/DSC_0373 (2).jpg";
import dentalImage from "./Images/how2.png";
// import building from './Images/Screenshot 2024-11-28 at 2.24.56 PM.png'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IoLocationOutline } from "react-icons/io5";
import { IoTimeOutline } from "react-icons/io5";
import {
  FaCoffee,
  FaChild,
  FaClock,
  FaRegCheckCircle,
  FaTv,
  FaCalendarCheck,
  FaTag,
  FaCreditCard,
  FaMedkit,
} from "react-icons/fa";
import dental1 from "../home/Images/v1.png";
import dental2 from "../home/Images/IMG20240913134831.jpg";
import dental3 from "../home/Images/IMG_20231201_174221.jpg";
import dental4 from "../home/Images/dental2.png";
function FreeConsultation() {
  const barItems = [
    {
      icon: <FaTv size={50} />,
      label: "TVs + Headphone",
    },
    {
      icon: <FaCalendarCheck size={50} />,
      label: "Curated Experience",
    },
    {
      icon: <FaTag size={50} />,
      label: "New Patient ",
    },
    {
      icon: <FaCreditCard size={50} />,
      label: "Flexible Bill Plans",
    },
    {
      icon: <FaCoffee size={50} />,
      label: "Beverage Bar",
    },
    {
      icon: <FaChild size={50} />,
      label: "Kids Corner",
    },
    { icon: <FaRegCheckCircle size={50} />, label: "OSHA Approved    " },
    { icon: <FaMedkit size={50} />, label: "Emergency" },
    { icon: <FaClock />, label: " TimeManagement  " },
  ];

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    draggable: false,
    swipe: false,
    centerMode: true, // This will center the middle item
    focusOnSelect: true, // Automatically focus on the selected item
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="freeconsult">
      <div className="freeconsult-sec1">
        {/* Section 1: Trusted Care */}
        <div className="content3">
          <div className="text-section">
            {/* <h1 className="section-header">SECTION 1</h1> */}
            <p className="trusted-text">
              <mark className="domark">FREE CONSULTATION PATIENT SPECIAL</mark>
            </p>
            <h1 className="exceptional">
              <mark className="expmrk">A reason to smile</mark>
            </h1>
            <a href="/booknow">
              <button className="book-button">BOOK ONLINE</button>
            </a>
            <p className="call-text">OR CALL <a href="tel:+918882672980">088826 72980</a></p>
            {/* <p className="call-text">9582474046</p> */}
          </div>
        </div>
      </div>
      <div className="free-sec6">
        <div className="home-sec6">
          <div className="insurance5"></div>
          <div
            className="transparent-pricing free-pricing"
            style={{
          
              padding: "0px 30px",
            }}
          >
            <h1>FREE Consultation For Life Time</h1>
            <p>
              FREE Consultation For Life Time As a benefit to our dedicated
              patients, Bombay Dental Company, Worli is happy to offer free
              dental consultations for life. Once a patient visits a Bombay
              Dental Company clinic, he becomes our patient for life. At Worli,
              we do not believe in charging our patients repeatedly for
              consultations every time they visit with a new dental concern. So
              here is our gift, after the first visit when you are charged for
              consultation, we add you to our mailing list with your permission,
              of course. Drop in for free dental check ups once every 6 months,
              ask us any questions you may have, we are happy to answer and help
              you.
            </p>
            <a className="offer-link">
              {" "}
              Book online now or call us at 8882672980
            </a>
          </div>
        </div>
      </div>

      <div className="home-sec2">
        <div className="home-sec2-box">
          <div className="home-sec2-content">
            <h1
              className="Dentist"
              style={{
                textAlign: "start",
                marginLeft: "15px",
              }}
            >
              How It Works
            </h1>
            <ul
              className="tickp"
            >
              <li className="listp">
                {" "}
                Our comprehensive warranty covers all types of Orthodontic
                treatments .
              </li>
              <li className="listp">
                Visit Bombay Dental Company every 6 months for routine cleanings
                and examinations{" "}
              </li>
              <li className="listp">
                {" "}
                If something breaks, contact us. We’ll fix it at no cost to you.
              </li>
            </ul>
          </div>
          <div className="home-sec2-img">
            <img
              src={dentalImage}
              alt="Dental Care"
              style={{
                width: "90%",

                objectFit: "cover",
              }}
            />
          </div>
        </div>
      </div>
      <div
        className="dental-bar-menu"
        style={{ margin: " 0 0px", backgroundColor: "white" }}
      >
        <h2
          className="menu-title"
          style={{ textAlign: "center", color: " black" }}
        >
          Bombay Dental Company Menu
        </h2>
        <Slider {...sliderSettings}>
          {barItems.map((item, index) => (
            <div
              key={index}
              className="menu-item"
              style={{ textAlign: "center", height: "100%" }}
            >
              <div
                className="icon"
                style={{ marginBottom: "10px", color: " #0047AB" }}
              >
                {item.icon}
              </div>
              <p className="label" style={{ color: " #0047AB" }}>
                {item.label}
              </p>
            </div>
          ))}
        </Slider>
      </div>

      <div className="visit-us-container">
        <div className="images-container">
          <img src={dental1} alt="Waiting Area" className="image-item" />
          <img src={dental2} alt="Exam Room" className="image-item" />
          <img src={dental3} alt="Sign" className="image-item" />
          <img src={dental4} alt="Lounge" className="image-item" />
        </div>
        <div className="info-container">
          <h1 className="visit">Visit Us</h1>
          <p className="weare">
            We are conveniently located right on the Worli Naka, on the first
            floor of Atur House, opposite the Bharat Petroleum Pump. Our guards
            are very helpful, and free parking is provided easily upon asking.
          </p>
          <div className="lhflex">
            <div className="location">
              <h1 className="tp">
                <IoLocationOutline />
              </h1>
              <p>
                {" "}
                Bombay Dental Company
                <br />
                Atur House
                <br />
                First Floor, Flat no 2<br />
                Worli Naka, Worli
                <br />
                Mumbai 400018
              </p>
              <a
                href="https://maps.google.com/?q=5Bombay%20Dental%20Company%20Atur%20House%20Worli%20Naka%20Mumbai%20400018"
                className="directions-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get Directions
              </a>
            </div>
            <div className="hours">
              <h1 className="tp">
                <IoTimeOutline />
              </h1>
              <p>
                {" "}
                Mon-Sat 9 am – 7 pm
                <br />
                Sun 10 am – 2 pm
                <br />
                Thursday off
              </p>
            </div>
          </div>
        </div>
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps?q=5Bombay+Dental+Company+Atur+House+Worli+Naka+Mumbai+400018&output=embed"
            width="100%"
            height="450"
            style={{ border: "8px", borderRadius: "18px " }}
            allowFullScreen
            loading="lazy"
            title="Google Maps Location of Bombay Dental Company"
          />
        </div>
      </div>
      <div className="home-sec8">
        <div className="book-visit-container">
          <div className="online">
            <h1 className="book">Book your visit online</h1>
            <p className="view">
              Book your visit online and enjoy our unique No-wait policy, so
              that you have time for what you enjoy, and not spend your precious
              time in the doctor’s waiting area. A few lucky callers every month
              will be randomly shortlisted for a free scaling and polishing
              session.
            </p>
            <a href="/booknow">
              {" "}
              <button className="book-button1">BOOK ONLINE</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FreeConsultation;
